export enum ModalType {
    AUTHORIZATION, DELETE, SUGGESTION, UPLOAD, INFO
}